import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";

function getSavedAdminUser() {
  try {
    const savedUser = localStorage.getItem("adminUser");
    return savedUser ? JSON.parse(savedUser) : null;
  } catch {
    return null;
  }
}

function NavBarAdmin() {
  const navigate = useNavigate();

  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [adminUser, setAdminUser] = useState(getSavedAdminUser());

  const isLoggedIn = Boolean(token);
  const role = adminUser?.Role || "";
  const fullName = adminUser?.FullName || "";
  const email = adminUser?.Email || "";

  const isAdmin = role === "ADMIN";

  useEffect(() => {
    function syncAuth() {
      setToken(localStorage.getItem("token") || "");
      setAdminUser(getSavedAdminUser());
    }

    window.addEventListener("storage", syncAuth);
    window.addEventListener("admin-auth-change", syncAuth);

    return () => {
      window.removeEventListener("storage", syncAuth);
      window.removeEventListener("admin-auth-change", syncAuth);
    };
  }, []);

  const handleLogin = () => {
    navigate("/admin/sign_in");
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("adminUser");
    localStorage.removeItem("tempToken");
    localStorage.removeItem("tempEmail");

    setToken("");
    setAdminUser(null);

    navigate("/admin/sign_in");
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-white border-b shadow-sm border-slate-200">
      <nav className="flex items-center justify-between px-4 py-3 mx-auto max-w-7xl md:px-8">
        {/* LEFT LOGO */}
        <Link to="/" className="flex items-center gap-3">
          <img
            src={logo}
            alt="Practical Infosec"
            className="object-contain w-auto h-12"
          />

          <div className="hidden sm:block">
            <h1 className="text-lg font-black leading-tight text-slate-950">
              Practical Infosec
            </h1>
            <p className="text-xs font-bold tracking-wide text-slate-500">
              Admin Panel
            </p>
          </div>
        </Link>

        {/* RIGHT SIDE */}
        <div className="flex items-center gap-3">
          {!isLoggedIn ? (
            <button
              type="button"
              onClick={handleLogin}
              className="px-5 py-2.5 text-sm font-black text-white transition rounded-xl bg-slate-950 hover:bg-blue-700"
            >
              Login
            </button>
          ) : (
            <>
              <div className="items-center hidden gap-3 px-4 py-2 border rounded-xl bg-slate-50 border-slate-200 md:flex">
                <div>
                  <p className="text-sm font-black text-slate-950">
                    {fullName || "Admin User"}
                  </p>
                  <p className="text-xs font-semibold text-slate-500">
                    {email}
                  </p>
                </div>

                {isAdmin && (
                  <span className="px-3 py-1 text-xs font-black text-white bg-green-600 rounded-full">
                    ADMIN
                  </span>
                )}
              </div>

              

              <button
                type="button"
                onClick={handleLogout}
                className="px-5 py-2.5 text-sm font-black text-white transition rounded-xl bg-red-600 hover:bg-red-700"
              >
                Logout
              </button>
            </>
          )}
        </div>
      </nav>

      {/* MOBILE ADMIN ROLE INFO */}
      {isLoggedIn && (
        <div className="px-4 pb-3 md:hidden">
          <div className="flex items-center justify-between gap-3 p-3 border rounded-xl bg-slate-50 border-slate-200">
            <div>
              <p className="text-sm font-black text-slate-950">
                {fullName || "Admin User"}
              </p>
              <p className="text-xs font-semibold text-slate-500">{email}</p>
            </div>

            {isAdmin && (
              <span className="px-3 py-1 text-xs font-black text-white bg-green-600 rounded-full">
                ADMIN
              </span>
            )}
          </div>
        </div>
      )}
    </header>
  );
}

export default NavBarAdmin;